import QuotationFormStepTypes from "./QuotationFormStepTypes";

const QuotationFormStepValidationTypes = {
  [QuotationFormStepTypes.SERVICE]: ["service"],
  [QuotationFormStepTypes.COSTS]: ["costs"],
  [QuotationFormStepTypes.SCHEDULE]: ["schedule"],
  [QuotationFormStepTypes.MISC]: ["additional_information", "service_confirmation"],
};

export default QuotationFormStepValidationTypes;
